var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 128,
    viewBox: "0 0 90 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.19995 51.2315C0.849962 50.6255 1.04908 49.8555 1.64469 49.5117L42.3119 26.0375C42.9075 25.6937 43.6741 25.9064 44.0241 26.5124L72.0446 75.0349C72.3946 75.641 72.1955 76.411 71.5999 76.7548L30.9326 100.229C30.3371 100.573 29.5705 100.36 29.2205 99.7545L1.19995 51.2315Z",
    fill: "white",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.94604 52.2352C4.59606 51.6292 4.79518 50.8592 5.39078 50.5154L41.3078 29.7831C41.9035 29.4393 42.67 29.652 43.02 30.2581L62.813 64.5332C63.163 65.1392 62.9639 65.9092 62.3683 66.2531L26.4513 86.9853C25.8556 87.3291 25.0891 87.1165 24.7391 86.5104L4.94604 52.2352Z",
    fill: "#CCCCCC",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.8264 73.1374C25.8357 72.367 26.522 71.7955 27.2764 71.9299L34.9867 73.3031C36.0792 73.4977 37.119 72.7998 37.3555 71.7131L41.023 54.8587C41.1623 54.2186 41.7673 53.8012 42.4132 53.8996L58.048 56.2803L62.814 64.5335C63.164 65.1395 62.9649 65.9095 62.3693 66.2533L27.5633 86.3442C26.7234 86.829 25.6668 86.1941 25.6788 85.2121L25.8264 73.1374Z",
    fill: "#F7F5F3",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.95 57.9311C22.0431 57.3001 22.4176 55.9027 21.7866 54.8099C21.1555 53.717 19.7577 53.3425 18.6646 53.9735C17.5715 54.6044 17.1969 56.0019 17.8281 57.0948C18.4592 58.1876 19.8569 58.5621 20.95 57.9311Z",
    fill: "#F7F5F3",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.29 40.397C39.3554 39.6488 40.014 39.0952 40.761 39.1605L87.2431 43.2263C87.9901 43.2917 88.5425 43.9511 88.4771 44.6993L83.6142 100.269C83.5488 101.017 82.8901 101.571 82.1432 101.506L35.6611 97.4401C34.9141 97.3747 34.3617 96.7147 34.4271 95.967L39.29 40.397Z",
    fill: "white",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.7835 43.3676C41.849 42.6194 42.5076 42.0659 43.2545 42.1312L84.2716 45.7189C85.0186 45.7843 85.5711 46.4438 85.5056 47.1919L82.077 86.3728C82.0115 87.1209 81.3529 87.6745 80.606 87.6091L39.5889 84.0214C38.8419 83.956 38.2894 83.2966 38.3549 82.5484L41.7835 43.3676Z",
    fill: "#CCCCCC",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M46.7947 72.5007C47.2841 71.8198 48.266 71.7405 48.8576 72.334L54.1376 77.6315C54.9956 78.4924 56.3795 78.521 57.2727 77.6961L69.721 66.2011C70.2473 65.7151 71.0596 65.7216 71.5777 66.2159L82.8962 77.0145L82.0773 86.3722C82.0118 87.1203 81.3532 87.6739 80.6063 87.6086L40.9567 84.1404C39.9077 84.0487 39.3582 82.8476 39.9735 81.9915L46.7947 72.5007Z",
    fill: "#F7F5F3",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6 57.0852C52.8572 57.1951 53.9657 56.2652 54.0757 55.0081C54.1857 53.7509 53.2556 52.6427 51.9983 52.5328C50.741 52.4228 49.6325 53.3527 49.5225 54.6099C49.4125 55.8669 50.3426 56.9752 51.6 57.0852Z",
    fill: "#F7F5F3",
    stroke: "#AE9F82",
    strokeWidth: 0.909091
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.2f8d5f48ae96110d21aae77c466d1c64.svg";
export { ForwardRef as ReactComponent };